import axios from "axios";
import { createContext, useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import axiosInstance from "../services/api/axiosInstance";
import { useDropzone } from "react-dropzone";
import { useNavigate } from "react-router-dom";
import { IoIosInformationCircleOutline } from "react-icons/io";
import Cookie from "js-cookie";
import Cookies from "js-cookie";

const PartnerContext = createContext();

export const DataProvider = ({ children }) => {

  // joyride
  const [subscriptionExpiredShow, setSubscriptionExpired] = useState(false);
  const partnerProfileDropdown = "partnerProfileDropdown";
  const partnerPool = "poolTab";


  useEffect(() => {
    setImageData([])
    setPdfData([])
    setImageBlob({})
    setPdfBlob({})
    setPageNumber(true)
    setJobAdStatus("Start with a new Ad post")
    setSelectedCard(false)
    setSelectedTemplateCard(true)
    setExistingAd(false)
    setImageStatus("")
  }, [])

  const pageRender = useNavigate();
  // Partner Form First Page
  const [review, setReview] = useState(false);

  const [pageNumber, setPageNumber] = useState(true);

  const [redirectPage, setRedirectPage] = useState(false);

  const [existingAd, setExistingAd] = useState(false)

  const [draftLoading, setDraftLoading] = useState(true)

  const [getCardApi, setGetCardApi] = useState([]);

  const [jobAdStatus, setJobAdStatus] = useState('Start with a new Ad post')

  const [draftId, setDraftId] = useState(0);

  const [updateButton, setUpdateButton] = useState(false);

  const [postDraftButton, setPostDraftButton] = useState(false)


  // Partner Home State for Mapping

  const [homeApiDataForMapping, setHomeApiDataMapping] = useState([])

  const [createNewAd, setCreateNewAd] = useState([]);

  const [getDraftData, setGetDraftData] = useState([]);

  const [selectedCard, setSelectedCard] = useState(false);

  const [selectedTemplateCard, setSelectedTemplateCard] = useState(false);

  const [pdfUrlToBlob, setPdfUrlToBlob] = useState([]);
  const [imageUrlToBlob, setImageUrlToBlob] = useState([]);

  const [postAdLoading, setPostAdLoading] = useState(false)

  const [updatedCardStatus, setUpdatedCardStatus] = useState("");

  // 204 post not left state

  const [adNotLeft, setAdNotLeft] = useState("")

  const [modalID, setModalId] = useState("adNotLeftModalButton")

  const handleNewOrDraftPost = (e) => {
    setJobAdStatus(e.target.value)
    if (e.target.value === "Start with a new Ad post") {
      setSelectedTemplateCard(true)
      setSelectedCard(false)

    }
    else if (e.target.value === 'Use Previous Posted Ad Template') {
      setSelectedTemplateCard(false)
      setSelectedCard(true)
      getPartnerDraftAds('')
    }
    else {
      setSelectedTemplateCard(false)
      setSelectedCard(true)
      getPartnerDraftAds('drafted')
    }
  }

  const handleCreateNewCard = () => {
    if (jobAdStatus === "Start with a new Ad post") {
      setPartnerHomeDatas({
        id: "",
        title: "",
        shortDescription: "",
        detailedDescription: "",
        link: "",
        image: "",
        pdf: ""
      })
      setImageData([])
      setPdfData([])
      setReview(false)
      setPageNumber(false)
      setUpdateButton(false)
      setPostDraftButton(false)
    }

    else {
      if (selectedTemplateCard || existingAd || jobAdStatus !== 'Start with a new Ad post') {
        if (selectedTemplateCard && jobAdStatus === 'Use draft') {
          var setDraft = getDraftData.find((v) => {
            return v.id === draftId
          })
          setPartnerHomeDatas({
            id: setDraft.id,
            title: setDraft.title,
            detailedDescription: setDraft.detailed_description,
            link: setDraft.url,
            image: setDraft.image,
            pdf: setDraft.attached_file
          })
          setUpdateButton(false)
          setPostDraftButton(true)
          setSelectedTemplateCard(false)
          setPageNumber(false)
          setReview(false)
        }
        else if (selectedTemplateCard && jobAdStatus === 'Use Previous Posted Ad Template') {
          var setPreviousTemplate = getDraftData.find((v) => {
            return v.id === draftId
          })
          setPartnerHomeDatas({
            title: setPreviousTemplate.title,
            detailedDescription: setPreviousTemplate.detailed_description,
            link: setPreviousTemplate.url,
            image: setPreviousTemplate.image,
            pdf: setPreviousTemplate.attached_file
          })
          setSelectedTemplateCard(false)
          setReview(false)
          setPageNumber(false)
          setUpdateButton(false)
          setPostDraftButton(true)
        }
      }
      else {
        toast("Select any template", {
          icon: (
            <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
          ),
        });
        setPageNumber(true)
      }
    }
  }


  // Partner Review and Second Page
  const [profilePicture, setProfilePicture] = useState("");


  const [imageData, setImageData] = useState([]);
  const [pdfData, setPdfData] = useState([]);


  const [imageStatus, setImageStatus] = useState("")

  const [partnerHomeDatas, setPartnerHomeDatas] = useState({
    id: "",
    title: "",
    detailedDescription: "",
    link: "",
    image: "",
    pdf: ""
  });

  const handleTitle = (e) => {
    setPartnerHomeDatas((prevState) => ({ ...prevState, title: e.target.value }))
  }


  const handleDetailedDescription = (e) => {
    setPartnerHomeDatas((prevState) => ({ ...prevState, detailedDescription: e.target.value }))
  }

  const handleLink = (e) => {
    setPartnerHomeDatas((prevState) => ({ ...prevState, link: e.target.value }))
  }




  const handleReviewButton = () => {

    if (partnerHomeDatas.title === "" ||
      imageData.length === 0 || partnerHomeDatas.link === ""
    ) {
      toast("Please fill all the details", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
    }
    else if (partnerHomeDatas.detailedDescription.length < 150) {
      toast("Please enter description between 150 and 600 characters", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
    }
    else {
      setRedirectPage(false)
      setReview(true)
    }
  }



  const handleBackButton = () => {
    setReview(false)
  }

  const [pdfBlob, setPdfBlob] = useState({})

  // Upload Pdf
  const onDropPdf = useCallback((acceptedFiles) => {
    var fileSize = acceptedFiles[0].size
    if (fileSize <= 5242880) {
      setPdfData([acceptedFiles[0].path]);
      setPdfBlob(...acceptedFiles)
    } else {
      toast.error("Please ensure that the Pdf size remains below 5MB")
    }
  }, []);

  const {
    getRootProps: getRootPropsPdf,
    getInputProps: getInputPropsPdf,
    isDragActive: isDragActivePdf,
  } = useDropzone({
    onDrop: onDropPdf,
    maxFiles: 1,
    accept: {
      "application/pdf": [],
    },
  });

  const [imageBlob, setImageBlob] = useState({})
  // Upload Image
  const onDropImage = useCallback((acceptedFiles) => {
    var fileSize = acceptedFiles[0].size
    if (fileSize <= 5242880) {
      setImageData([acceptedFiles[0].path]);
      setImageBlob(...acceptedFiles)
    } else {
      toast.error("Please ensure that the Image size remains below 5MB")
    }
  }, []);



  const {
    getRootProps: getRootPropsImage,
    getInputProps: getInputPropsImage,
    isDragActive: isDragActiveImage,
  } = useDropzone({
    onDrop: onDropImage,
    maxFiles: 1,
    accept: {
      'image/png': ['.png'],
      'image/jpeg': ['.jpg', '.jpeg'],
    },
  });


  // Post New Ad
  const handlePostAdApi = async (e, draftOrAd) => {
    const token = Cookie.get("prToken");

    if (draftOrAd === "opened") {
      var formData = new FormData();
      formData.append("title", partnerHomeDatas.title);
      formData.append("detailed_description", partnerHomeDatas.detailedDescription);
      formData.append("url", partnerHomeDatas.link);
      formData.append("post_status", "opened");
      formData.append("is_image_changed", imageStatus === '' && jobAdStatus !== "Start with a new Ad post" ? "N" : "Y")
      formData.append("from_draft", jobAdStatus === "Use draft" ? "Y" : "N")

      if (imageBlob.size === undefined) {
        formData.append("cover_pic", imageUrlToBlob);
      } else {
        formData.append("cover_pic", imageBlob);
      }


      if (pdfBlob.size === undefined) {
        formData.append("attached_file", pdfUrlToBlob);
      } else {
        formData.append("attached_file", pdfBlob);
      }

      try {

        const config = {
          headers: {
            "content-type": "multipart/form-data",
            authorization: `Bearer ${token}`,
          },
        };

        const response = await axiosInstance.post(`/create_post`, formData, config)

        if (response.data.error_code === 0) {
          setPostAdLoading(false)
          pageRender('/partner_dashboard/home')

          setPartnerHomeDatas({
            id: "",
            title: "",
            detailedDescription: "",
            link: "",
            image: "",
            pdf: ""
          })
          setImageData([]);
          setPdfData([]);
          setPdfBlob({});
          setImageBlob({});
          setImageUrlToBlob([]);
          setPdfUrlToBlob([]);
          setImageStatus("")
        }
        else if (response.data.error_code = 201) {
          setAdNotLeft(response.data.message)

          setPostAdLoading(false)
          handleAdfNotLeftModalButton()

        }

      }
      catch (err) {
        console.log(err)
      }
    }
    else {
      var formDraftData = new FormData();
      formDraftData.append("title", partnerHomeDatas.title);
      formDraftData.append("detailed_description", partnerHomeDatas.detailedDescription);
      formDraftData.append("url", partnerHomeDatas.link);
      formDraftData.append("attached_file", pdfBlob.size === undefined ? partnerHomeDatas.pdf : pdfBlob);
      formDraftData.append("cover_pic", imageBlob.size === undefined ? partnerHomeDatas.image : imageBlob);
      formDraftData.append("post_status", "drafted");



      try {

        setPostAdLoading(true)
        const config = {
          headers: {
            "content-type": "multipart/form-data",
            authorization: `Bearer ${token}`,
          },
        };

        const response = await axiosInstance.post(`/draft_post`, formDraftData, config)

        if (response.data.error_code === 0) {

          setPostAdLoading(false)
          pageRender('/partner_dashboard/home')
          setPartnerHomeDatas({
            id: "",
            title: "",
            detailedDescription: "",
            link: "",
            image: "",
            pdf: ""
          })
          setImageData([]);
          setPdfData([]);
          setPdfBlob({});
          setImageBlob({});
          setImageUrlToBlob([]);
          setPdfUrlToBlob([]);
          setImageStatus("")
        }

      }
      catch (err) {
        console.log(err)
      }
    }
  }


  const handleAdfNotLeftModalButton = () => {
    var popup = document.getElementById("adNotLeftModalButton")

    popup.click()
  }

  const handleDraftPost = async () => {
    setPostAdLoading(true)

    if (partnerHomeDatas.title === "" ||
      imageData.length === 0 || partnerHomeDatas.link === ""
    ) {
      toast("Please fill all the details", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
    } else if (partnerHomeDatas.detailedDescription.length < 150) {
      toast("Please enter between 150 and 600 characters", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
    }

    else {

      const token = Cookie.get("prToken");
      try {
        var formData = new FormData();
        formData.append("key_id", partnerHomeDatas.id === undefined ? '' : partnerHomeDatas.id);
        formData.append("title", partnerHomeDatas.title);
        formData.append("detailed_description", partnerHomeDatas.detailedDescription);
        formData.append("url", partnerHomeDatas.link);
        formData.append("post_status", "opened");
        formData.append("is_image_changed", imageStatus === '' ? "N" : "Y")
        formData.append("from_draft", jobAdStatus === "Use draft" ? "Y" : "N")

        if (imageBlob.size === undefined) {
          formData.append("cover_pic", imageUrlToBlob);
        } else {
          formData.append("cover_pic", imageBlob);
        }


        if (pdfBlob.size === undefined) {
          formData.append("attached_file", pdfUrlToBlob);
        } else {
          formData.append("attached_file", pdfBlob);
        }

        const config = {
          headers: {
            "content-type": "multipart/form-data",
            authorization: `Bearer ${token}`,
          },
        };

        const response = await axiosInstance.post('/create_post', formData, config)

        if (response.data.error_code === 0) {
          setPostAdLoading(false)
          pageRender('/partner_dashboard/home')

          setPartnerHomeDatas({
            id: "",
            title: "",
            detailedDescription: "",
            link: "",
            image: "",
            pdf: ""
          })

        }
        else if (response.data.error_code = 201) {
          setAdNotLeft(response.data.message)

          setPostAdLoading(false)
          handleAdfNotLeftModalButton()
        }
        setImageData([]);
        setPdfData([]);
        setPdfBlob({});
        setImageBlob({});
        setImageUrlToBlob([]);
        setPdfUrlToBlob([]);
        setUpdatedCardStatus("")
        setImageStatus("")
      }
      catch (err) {
        console.log(err)
      }
    }
  }


  // Update Old Template
  const handleUpdateAd = async (e, status) => {

    setPostAdLoading(true)

    if (partnerHomeDatas.title === "" ||
      imageData.length === 0 || partnerHomeDatas.link === ""
    ) {
      toast("Please fill all the details", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
    } else if (partnerHomeDatas.detailedDescription.length < 150) {
      toast("Please enter between 150 and 600 characters", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
    }

    else {

      const token = Cookie.get("prToken");
      try {
        var formData = new FormData();
        formData.append("key_id", partnerHomeDatas.id === undefined ? '' : partnerHomeDatas.id);
        formData.append("title", partnerHomeDatas.title);
        formData.append("detailed_description", partnerHomeDatas.detailedDescription);
        formData.append("url", partnerHomeDatas.link);
        formData.append("post_status", "opened");
        formData.append("is_image_changed", imageStatus === '' ? "N" : "Y")
        formData.append("from_draft", jobAdStatus === "Use draft" ? "Y" : "N")

        if (imageBlob.size === undefined) {
          formData.append("cover_pic", imageUrlToBlob);
        } else {
          formData.append("cover_pic", imageBlob);
        }


        if (pdfBlob.size === undefined) {
          formData.append("attached_file", pdfUrlToBlob);
        } else {
          formData.append("attached_file", pdfBlob);
        }

        const config = {
          headers: {
            "content-type": "multipart/form-data",
            authorization: `Bearer ${token}`,
          },
        };

        const response = await axiosInstance.post('/edit_partner_post', formData, config)

        if (response.data.error_code === 0) {
          setPostAdLoading(false)
          pageRender('/partner_dashboard/home')

          setPartnerHomeDatas({
            id: "",
            title: "",
            detailedDescription: "",
            link: "",
            image: "",
            pdf: ""
          })

        }
        else if (response.data.error_code = 201) {
          setAdNotLeft(response.data.message)

          setPostAdLoading(false)
          handleAdfNotLeftModalButton()
        }
        setImageData([]);
        setPdfData([]);
        setPdfBlob({});
        setImageBlob({});
        setImageUrlToBlob([]);
        setPdfUrlToBlob([]);
        setUpdatedCardStatus("")
        setImageStatus("")
      }
      catch (err) {
        console.log(err)
      }
    }
  }


  // Get Draft Datas
  const getPartnerDraftAds = async (getValue) => {

    setDraftLoading(false)

    const homeParams = {
      "ad_status": getValue
    }
    try {
      const response = await axiosInstance.post("/get_ad_post", homeParams)
      setDraftLoading(true)
      if (response.data.error_code === 0) {
        setReview(false)
        setGetDraftData(response.data.data)
      }

    }
    catch (error) {
      console.log(error)
    }
  }


  const handlePostAd = (e, draftOrAd) => {
    if (draftOrAd !== 'Draft') {


      if (partnerHomeDatas.title === "" ||
        imageData.length === 0 || partnerHomeDatas.link === ""
      ) {
        toast("Please fill all the details", {
          icon: (
            <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
          ),
        });
      } else if (partnerHomeDatas.detailedDescription.length < 150) {
        toast("Please enter between 150 and 600 characters", {
          icon: (
            <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
          ),
        });
      }
      else {
        handlePostAdApi(e, draftOrAd)
        setPostAdLoading(true)
      }
    }
    else {
      if (partnerHomeDatas.title === "") {
        toast("Please fill the details", {
          icon: (
            <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
          ),
        });
      }
      else {
        handlePostAdApi(e, draftOrAd)
        setPostAdLoading(true)
      }
    }
  }


  //  Pricing****************************************************************************************************************************************************

  const [checkOutStatus, setCheckOutStatus] = useState({
    paymentStatus: '',
    productPlan: ''
  })

  const [country, setCountry] = useState("")

  const [countryLoading, setCountryLoading] = useState(false)

  const getCoordinates = async () => {
    let getCountryParameters = { lat: '', lon: '' };

    const getPosition = () =>
      new Promise((resolve, reject) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;
              resolve({ lat: latitude.toString(), lon: longitude.toString() });
            },
            (error) => {
              reject(error);
            }
          );
        } else {
          reject(new Error('Geolocation is not supported by this browser.'));
        }
      });

    try {
      getCountryParameters = await getPosition();
    } catch (error) {
      getCountryParameters = { lat: '11.0263', lon: '77.1599' }; // Default values
    }


    return getCountryParameters;
  };

  const [subscription_going_to_end, set_subscription_going_to_end] = useState(0);
  const [is_trial_started, set_is_trial_started] = useState("")
  const [pricingResponse, setPricingResponse] = useState({})

  const updateCheckoutStatus = async () => {
    try {
      const getCountryParameters = await getCoordinates();
      setCountryLoading(true)

      const response = await axiosInstance.post("/get_checkout_status", getCountryParameters);
      if (response.data.error_code === 0) {
        setCountryLoading(false)
        setCheckOutStatus({ paymentStatus: response.data.data.payment_status, productPlan: response.data.data.product_plan, is_cancelled: response.data.data?.is_cancelled })
        set_is_trial_started(response.data.data.is_trial_started)
        setCountry(response.data.data.country)
        setPricingResponse(response.data.data)
        set_subscription_going_to_end(response.data?.data?.remaining_days)
        if (response.data.data?.product_plan) {
          Cookies.set("pricing_category", response.data.data?.product_plan);
        }
      } else {
        toast(response.data.message, {
          icon: (
            <h4><IoIosInformationCircleOutline className="brand-color me-1" /></h4>
          )
        });
      }
    } catch (error) {
      console.log(error)
    }
  }


  return (
    <PartnerContext.Provider
      value={{

        // Pricing
        country,
        setCountry,
        checkOutStatus,
        setCheckOutStatus,
        countryLoading,
        setCountryLoading,



        profilePicture,
        setProfilePicture,


        // Partner Home
        homeApiDataForMapping,
        setHomeApiDataMapping,
        redirectPage,
        setRedirectPage,
        createNewAd,
        setCreateNewAd,
        getDraftData,
        setGetDraftData,
        selectedCard,
        setSelectedCard,
        selectedTemplateCard,
        setSelectedTemplateCard,
        review,
        setReview,
        existingAd,
        setExistingAd,
        jobAdStatus,
        setJobAdStatus,
        updatedCardStatus,
        setUpdatedCardStatus,
        updateButton,
        setUpdateButton,
        postDraftButton,
        setPostDraftButton,
        draftId,
        setDraftId,
        imageData,
        setImageData,
        imageBlob,
        pdfBlob,
        setPdfBlob,
        setImageBlob,
        imageStatus,
        setImageStatus,
        partnerHomeDatas,
        setPartnerHomeDatas,
        handleTitle,
        // handleShortDescription,
        handleDetailedDescription,
        handleLink,
        handleReviewButton,
        handleBackButton,
        handlePostAd,
        handleUpdateAd,
        handleDraftPost,
        getPartnerDraftAds,
        handleNewOrDraftPost,
        onDropImage,
        getRootPropsImage,
        getInputPropsImage,
        isDragActiveImage,
        // Drop Pdf
        pdfData,
        setPdfData,
        onDropPdf,
        getRootPropsPdf,
        getInputPropsPdf,
        isDragActivePdf,

        // Partner Home Review
        pageNumber,
        setPageNumber,
        handleCreateNewCard,
        draftLoading,
        setDraftLoading,
        getCardApi,
        setGetCardApi,
        pdfUrlToBlob, setPdfUrlToBlob,
        imageUrlToBlob, setImageUrlToBlob,
        postAdLoading, setPostAdLoading,
        adNotLeft,
        setAdNotLeft,
        handleAdfNotLeftModalButton,

        // Joyride
        partnerProfileDropdown,
        partnerPool,
        subscriptionExpiredShow, setSubscriptionExpired,
        subscription_going_to_end, set_subscription_going_to_end,
        is_trial_started, set_is_trial_started,
        pricingResponse, setPricingResponse, updateCheckoutStatus
      }}
    >
      {children}
    </PartnerContext.Provider>
  );

};

export default PartnerContext;
